import { NotificationsPage } from '@icoach/notifications/';
import { NOTIFICATIONS_ROUTER } from '@icoach/router/routerPath';

// 通知管理
const notificationsRouter = [
    {
        description: '通知管理',
        strict: true,
        path: NOTIFICATIONS_ROUTER.BASE,
        as: NotificationsPage,
        frontKey: 'CXX99901',
    },
];

export default notificationsRouter;
